'use client';

/**
 * Base Primary Nav Button styles
 */

import { styled } from 'styled-components';
import { buttonReset, theme } from '@frameio/vapor';

export const StyledIcon = styled.button`
  ${buttonReset};
  align-items: center;
  border-radius: ${theme.radii[4]};
  box-shadow: none;
  color: ${theme.colors.icon.secondary};
  cursor: pointer;
  display: flex;
  height: ${theme.spaces[32]};
  justify-content: center;
  outline: none;
  padding: 0;
  transform: scale(1);
  transition-duration: 0.25s;
  transition-property: transform, color, box-shadow;
  transition-timing-function: ${theme.transitions.eases.primary};
  vertical-align: middle;
  width: ${theme.spaces[32]};

  &:not([aria-current='page']):not([aria-expanded='true']):hover,
  &:not([aria-current='page']):not([aria-expanded='true']):focus-visible {
    color: ${theme.colors.text.secondary};
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px ${theme.colors.border.interactive.focused};
  }

  &:active {
    transform: scale(0.95);
  }

  &[aria-current='page'],
  &[aria-expanded='true'] {
    color: ${theme.colors.text.primary};
  }
`;
